import AgendaTab from "accountOwner/pages/Scheduler/YourScheduleTab/SubTabs/AgendaTab";
import React from "react";
import { withTranslation } from "react-i18next";

const MySchedule = ({
  agendaFiltersData,
  staffAvailabilityViewSelectedFromDashBoard,
  currentDateFromDashBoard,
  setCurrentDateFromDashBoard,
  appliedAgendaTypes,
  appliedViewSettig,
  appliedOfficeFilters,
  isEnterpriseFilterActive,
}) => {
  return (
    <AgendaTab
      agendaFiltersData={agendaFiltersData}
      isFromDashBoard={true}
      staffAvailabilityViewSelectedFromDashBoard={
        staffAvailabilityViewSelectedFromDashBoard
      }
      currentDateFromDashBoard={currentDateFromDashBoard}
      setCurrentDateFromDashBoard={setCurrentDateFromDashBoard}
      appliedAgendaTypes={appliedAgendaTypes}
      appliedViewSettig={appliedViewSettig}
      appliedOfficeFilters={appliedOfficeFilters}
      isEnterpriseFilterActive={isEnterpriseFilterActive}
    />
  );
};

export default withTranslation()(MySchedule);
